import { createContext, useContext } from 'react';

import type { EventContext, SubscribeArgs, UseEvents } from './types';

const eventContextDefault: EventContext = {
    eventPrefix: ''
};

const context = createContext(eventContextDefault);

const useEvents: UseEvents = () => {
    const { eventPrefix } = useContext(context);

    const getEventType = (eventType: string) =>
        eventPrefix ? `${eventPrefix}.${eventType}` : eventType;

    const publish = (event: Event) => {
        const prefixedType = getEventType(event.type);

        const prefixedEvent =
            event instanceof CustomEvent
                ? new CustomEvent(prefixedType, { detail: event.detail })
                : new Event(prefixedType);

        window.dispatchEvent(prefixedEvent);
    };

    const subscribe = ({ callback, eventType }: SubscribeArgs) => {
        window.addEventListener(getEventType(eventType), callback);
    };

    const unsubscribe = ({ callback, eventType }: SubscribeArgs) => {
        window.removeEventListener(getEventType(eventType), callback);
    };

    return {
        context,
        eventPrefix,
        publish,
        subscribe,
        unsubscribe
    };
};

export default useEvents;
